import ModalFutureAbsence from "root/s360components/Modals/FutureAbsence/ModalFutureAbsence";
import Modal from "react-responsive-modal";
import {validateMode} from "root/Modals/modalFunctions";
import {useRef, useState} from "react";



export const ModalFutureAbsenceModes = {
    CREATE: 'create',
    EDIT: 'edit',
    DELETE: 'delete',
    NONE: 'none'
}

const useModalFutureAbsence = () =>
{
    const defaultState =  { openState: false, mode: ModalFutureAbsenceModes.NONE, school_id: null } ;

    const [dialog, setDialog]  = useState ( defaultState )  ;

    //Success of submission
    const resolvePromise = useRef(null);

    const onClickActivate = ( { mode, school_id, longTermAbsenceID } ) =>
    {
        validateMode(mode, ModalFutureAbsenceModes);

        return new Promise((resolve, reject) => {

            resolvePromise.current = resolve ;

            switch ( mode )
            {
                case ModalFutureAbsenceModes.CREATE:
                    setDialog ({ openState: true, mode: mode, school_id: school_id, longTermAbsenceID: null}); //Don't pass id in here as this is creating a new one
                    break ;
                case ModalFutureAbsenceModes.EDIT:
                    setDialog ({ openState: true, mode: mode, school_id: school_id, longTermAbsenceID: longTermAbsenceID});
                    break ;
                case ModalFutureAbsenceModes.DELETE:
                    setDialog ({ openState: true, mode: mode, school_id: school_id, longTermAbsenceID: longTermAbsenceID});
                    break ;
            }
        })
    }

    const onCloseModal = () =>
    {
        setDialog (defaultState);

        if ( resolvePromise.current !== null )
        {
            resolvePromise.current ( 'cancel' ) ;
        }
    };

    const onSaveComplete = ( result ) =>
    {
        // Close the dialog
        setDialog (defaultState);

        // Tell the parent we're done
        if ( resolvePromise.current !== null )
        {
            resolvePromise.current ( result ) ;
        }
    };

    const render = ( ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} onClose={onCloseModal}>
                < ModalFutureAbsence onClose={onCloseModal} mode={dialog.mode} longTermAbsenceID={dialog.longTermAbsenceID} onSaveComplete={onSaveComplete} school_id={dialog.school_id}/>
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalFutureAbsence;